import React from "react";

export const Logo = ({ className = "h-10" }) => (
  <img
    src="https://customer-assets.emergentagent.com/job_sales-catalog-hub-1/artifacts/uc7e4kb3_giotto-hor-bordo-carni.png"
    alt="Giotto Carni"
    className={className}
  />
);
